import { render, staticRenderFns } from "./subMenu.vue?vue&type=template&id=88b8d9ea&functional=true&"
import script from "./subMenu.vue?vue&type=script&lang=ts&"
export * from "./subMenu.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports